import { Link, useNavigate } from "react-router-dom";
import HeaderImg from "../components/HeaderImg";
import { useEffect, useState } from "react";
import hero1 from "../assets/images/hero/1.jpeg";
import hero2 from "../assets/images/hero/2.jpeg";
import hero3 from "../assets/images/hero/3.jpeg";
import hero4 from "../assets/images/hero/4.jpeg";
import hero5 from "../assets/images/hero/5.jpeg";
import hero6 from "../assets/images/hero/6.jpeg";
import hero7 from "../assets/images/hero/7.jpeg";

import Modal from "react-modal";
import {
  Input,
  Label,
  Textarea,
} from "../components/styledComponent/formInputs";
import Loading from "../components/Loading";
import { toast } from "react-toastify";

const programs = [
  {
    id: "cna",
    title: "Certified Caregiving Training",
    durationLabel: "6 or 12 months",
    desc: "Comprehensive caregiving training covering early identification, referral, screening, assessment and diagnostic services.",
    prices: {
      6: "₦350,000",
      12: "₦650,000",
    },
    img: hero1,
  },
  {
    id: "med-tech",
    title: "Certified Medical & Surgical Equipment Technical Training",
    durationLabel: "6 or 12 months",
    desc: "Hands-on technical training on installation, repair, maintenance, troubleshooting, and calibration of medical devices including monitors, diagnostic equipment, and surgical tools.",
    prices: {
      6: "₦200,000",
      12: "₦350,000",
    },
    img: hero4,
  },
];

const Training = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [inputError, setInputError] = useState({});
  const [program, setProgram] = useState({});
  const navigate = useNavigate();

  const [selected, setSelected] = useState(
    programs.reduce((acc, p) => ({ ...acc, [p.id]: 6 }), {}),
  );

  const validate = () => {
    let errors = {};

    if (!firstName || firstName.length < 2) {
      errors.firstName = "First name is required";
    }

    if (!lastName || lastName.length < 2) {
      errors.lastName = "Last name is required";
    }

    if (!phone || phone.length < 7) {
      errors.phone = "Valid phone number required";
    }

    if (!email || email.length < 5) {
      errors.email = "Valid email required";
    }

    setInputError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const data = {
        program: program?.title || "",
        duration: selected?.[program.id] || "",
        price: program?.prices?.[selected[program.id]] || "",
        firstName,
        lastName,
        phone,
        email,
      };

      setLoading(false);
      setFirstName("");
      setLastName("");
      setPhone("");
      setEmail("");
      toast.success("Enrollment submitted successfully");
      setModalIsOpen(false);
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong");
    }
  };

  const handleSelect = (programId, months) => {
    setSelected((s) => ({ ...s, [programId]: months }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  console.log("selected", selected);
  return (
    <div>
      <Modal
        className="modalMain"
        overlayClassName="modal-overlayCenter"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
      >
        <div className="trainingModal">
          <button
            className="trainingModal__close"
            onClick={() => setModalIsOpen(false)}
          >
            ✕
          </button>

          <h3 className="trainingModal__title">Program Enrollment</h3>

          {/* PROGRAM SUMMARY */}
          <div className="trainingModal__summary">
            <h4>{program.title}</h4>
            <div className="trainingModal__meta">
              <span>
                Duration: <strong>{selected?.[program.id] || 0} months</strong>
              </span>
              <span>
                Price:{" "}
                <strong>
                  {program?.prices?.[selected[program.id]] || "₦0"}
                </strong>
              </span>
            </div>
          </div>

          {/* FORM */}
          <div className="trainingModal__form">
            <div>
              <Label htmlFor="firstName">
                First Name <span>*</span>
              </Label>
              <Input
                id="firstName"
                value={firstName}
                error={!!inputError.firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>

            <div>
              <Label htmlFor="lastName">
                Last Name <span>*</span>
              </Label>
              <Input
                id="lastName"
                value={lastName}
                error={!!inputError.lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>

            <div>
              <Label htmlFor="phone">
                Phone Number <span>*</span>
              </Label>
              <Input
                id="phone"
                value={phone}
                error={!!inputError.phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <div>
              <Label htmlFor="email">
                Email <span>*</span>
              </Label>
              <Input
                id="email"
                value={email}
                error={!!inputError.email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button
              style={{ marginTop: 20 }}
              className="btn"
              onClick={handleSubmit}
            >
              {loading ? <Loading button /> : "Submit Enrollment"}
            </button>
          </div>
        </div>
      </Modal>

      <HeaderImg title="Training" />
      <section className="training">
        <div className="training__programs">
          <h1>Our Training Programmes</h1>
          <p className="training__programs__descMain">
            {" "}
            Chaol's capacity building programmes are designed to practically
            equip enrollees with technical skills to provide modern solutions to
            medical, surgical and different special needs areas. Through a blend
            of classroom instructions and hands-on practice, participants gain
            the confidence and competence required to excel in these skills.
          </p>
          <div className="training__programs__grid">
            {programs.map((item) => (
              <div
                className="training__programs__card"
                key={item.id}
                data-program={item.id}
              >
                <div className="training__programs__card__img">
                  <img src={item?.img} alt="" />
                </div>
                <div className="training__programs__card__head">
                  <h3 className="training__programs__title">{item.title}</h3>
                  <span className="training__programs__duration">
                    {item.durationLabel}
                  </span>
                </div>

                <p className="training__programs__desc">{item.desc}</p>

                <div
                  className="training__programs__price-toggle"
                  role="tablist"
                  aria-label={`${item.title} duration`}
                >
                  <button
                    className={`training__programs__toggle ${selected[item.id] === 6 ? "active" : ""}`}
                    onClick={() => handleSelect(item.id, 6)}
                    aria-pressed={selected[item.id] === 6}
                  >
                    6 months
                  </button>
                  <button
                    className={`training__programs__toggle ${selected[item.id] === 12 ? "active" : ""}`}
                    onClick={() => handleSelect(item.id, 12)}
                    aria-pressed={selected[item.id] === 12}
                  >
                    12 months
                  </button>

                  <div className="training__programs__price-pill" aria-hidden>
                    <span className="training__programs__price-label">
                      Price
                    </span>
                    <strong className="training__programs__price">
                      {item.prices[selected[item.id]]}
                    </strong>
                  </div>
                </div>

                <div className="training__programs__actions">
                  <button
                    onClick={() =>
                      navigate("/checkout-enroll", {
                        state: { program: item, duration: selected[item.id] },
                      })
                    }
                    className="training__programs__btn training__programs__btn--primary"
                    // onClick={() => {
                    //   setProgram(item);
                    //   setModalIsOpen(true);
                    // }}
                  >
                    Enroll
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits — horizontal flex with boxicons */}
        <div className="training__programs__benefits">
          <h3 className="training__programs__benefits__heading">
            Why train with us
          </h3>
          <div className="training__programs__benefits__row">
            <div className="training__programs__benefit">
              <i
                className="bx bx-hand training__programs__benefit__icon"
                aria-hidden="true"
              />
              <div>
                <strong>Hands-on experience</strong>
                <p>
                  Practical training using real medical and surgical equipment
                  to build confidence and job-ready skills.
                </p>
              </div>
            </div>

            <div className="training__programs__benefit">
              <i
                className="bx bx-user-id-card training__programs__benefit__icon"
                aria-hidden="true"
              />
              <div>
                <strong>Experienced instructors</strong>
                <p>
                  Practitioners with industry experience and clear guidance.
                </p>
              </div>
            </div>

            <div className="training__programs__benefit">
              <i
                className="bx bx-briefcase training__programs__benefit__icon"
                aria-hidden="true"
              />
              <div>
                <strong>Career support</strong>
                <p>Placement guidance and employer connections.</p>
              </div>
            </div>

            <div className="training__programs__benefit">
              <i
                className="bx bx-certification training__programs__benefit__icon"
                aria-hidden="true"
              />
              <div>
                <strong>Certification</strong>
                <p>Receive recognized certification on completion.</p>
              </div>
            </div>
          </div>
        </div>
        <section className="about__main__gallery">
          <img src={hero7} alt="" />
          <img src={hero2} alt="" />
          <img src={hero3} alt="" />
          <img src={hero6} alt="" />
          <img src={hero5} alt="" />
          {/* <img src={hero2} alt="" /> */}
          {/* <img src={hero3} alt="" />
                    <img src={hero1} alt="" /> */}
        </section>

        {/* CTA */}
        {/* <div className="training__cta">
          <h2>Ready to advance your skills?</h2>
          <Link to="/contact" className="btn-primary">
            Register for a Program
          </Link>
        </div> */}
      </section>
    </div>
  );
};

export default Training;
